import React, {Component, Fragment, useState} from 'react'
import classnames from "classnames";

export default function TinymceFloatPanel(props) {
  const { style, children } = props;
  const [initialized, setInitialized] = useState(false);

  setTimeout(() => {
    setInitialized(true);
  }, 1);

  return (
    <div className={classnames("mce-container mce-panel mce-floatpanel mce-menu mce-animate mce-fixed mce-menu-align", {"mce-in": initialized})} role="application" style={style}>
      <div className="mce-container-body mce-stack-layout" role="menu">
        { children }
      </div>
    </div>
  );
}
